"use strict";

/**
* Тип прав на объекты системы.
* @since 5.0.0.4204
* @readonly
* @enum {string} ACCESS_RIGHTS
* @example 
* WebAccess.task.setAttachmentsRights(ИДзадачи, ACCESS_RIGHTS.VIEW);
*/
var ACCESS_RIGHTS = {
  /** Пусто. */
  EMPTY: 0,
  /** Нет доступа. */
  NO_ACCESS: 2,
  /** Просмотр. */
  VIEW: 4,
  /** Изменение. */
  CHANGE: 8,
  /** Полные права. */
  FULL: 16
};


/**
* Типы поддерживаемых команд.
* @since 5.0.0.1600
* @enum {string} COMMAND_TYPE
* @readonly
*/
var COMMAND_TYPE = {
  SHOW_DIALOG: 1,
  END: 2,
  EXECUTE_SEARCH: 3,
  EXECUTE_JS_ACTION: 4,
  SHOW_MESSAGE_BOX: 5,
  SHOW_NOTIFICATION: 6,
};

/** 
* Базовый объект клиентской модели 
* @class BaseObjectModel
* @extends BaseObject
* @param {object} data Данные модели.
* @property {string} className имя класса
* @property {object} rawData загруженный json
*/
var BaseObjectModel = BaseObject.extend({

  /**
  * Конструктор
  * @private
  */
  init: function (data) {
    this._super(data);
    //Если данные были переданы в коструктор, то загрузим их  
    if (arguments.length > 0) this.load(data);
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  className: "BaseObjectModel",
  rawData: {},
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /* 
  * Загрузка данных текущего объекта
  * @method 
  * @param {object} JSONData
  */
  load: function (JSONData) {
    // Создаем событие "ДоЗагрузкиДанных" - 
    // может пригодиться если нам, вдруг, понадобиться подменить данные еще до включения в объект
    this.rawData = JSONData;
    this.fire("BeforeDataLoad", this.rawData);
    // Загружаем данные    
    $.extend(this, this.rawData);
    // Создаем событие "ПослеЗагрузкиДанных"
    this.fire("AfterDataLoad", this.rawData);
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Преобразовать ссылку на объект в объект типа WA.URL.
  *
  * @method WebAccess.mixins.linkMixin#toURL
  * @return {WebAccess.URL} Объект типа URL.
  */
  toURL: function () {
    var link = new WA.Link(this.ID, this.Type, this.ReferenceCode);
    var url = new WA.URL(link);
    if (this.IsNew) {
      url.setParam('mode', 'edit');
    };
    return url;
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Запуск действия.
  * @since 5.0.0.1600
  * @function BaseObjectModel.executeAction
  * @param {string} actionName Имя действия.
  * @param {object|WebAccess.components.dialogs.FormDialog} [opt_params] Параметры действия или диалог, тогда значения реквизитов диалога скопируются в параметры объекта для работы действия.
  * @example 
  * WebAccess.current.executeAction('ActionName').done(function() { console.log('Действие завершилось!'); });
  */
  executeAction(actionName, opt_params) {
    let entityLink = new WA.Link(this.ID, this.Type, this.ReferenceName);
    return WA.actions.executeAction(actionName, entityLink, this.form, opt_params)
  },

  /**
  * Выполняет прикладной метод.
  * @function BaseObjectModel.executeEntityMethod
  * @param {string} methodName Имя метода.
  * @param {object} [opt_parameters] Параметры, с которыми должен вызываться метод.
  * @since 5.5.0.1000
  
  * @example 
  * WebAccess.current.executeEntityMethod('MethodName').done(function(result) { console.log(result); });
  */
  executeEntityMethod(methodName, opt_parameters) {
    throw new Error("Abstract method!");
  },
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
    * Запуск действия с предварительный показов диалога.
    * @since 5.0.0.1901
    * @function BaseObjectModel.showDialogAndExecuteAction
    * @param {string} actionName Имя действия.
    * @param {string} dialogName Имя диалога.
    * @example 
    * WebAccess.current.showDialogAndExecuteAction('ActionName','DialogName').done(function() { console.log('Действие завершилось!'); });
    */
  showDialogAndExecuteAction(actionName, dialogName) {
    let entityLink = new WA.Link(this.ID, this.Type, this.ReferenceName);
    return WA.actions.showDialogAndExecuteAction(actionName, dialogName, entityLink, this.form)
  },
});







